import { createSelector } from '@ngrx/store';
import { selectShippingConditionsState } from '../reducers';
import * as fromCxShippingCondition from '../reducers/cx-shipping-condition.reducer';
import { CxShippingCondition } from '../../models/shipping-condition';

export const selectCxShippingConditions = createSelector(
  selectShippingConditionsState,
  fromCxShippingCondition.selectAll,
);
export const selectCxShippingConditionIds = createSelector(
  selectShippingConditionsState,
  fromCxShippingCondition.selectIds,
);
export const selectCxShippingConditionEntities = createSelector(
  selectShippingConditionsState,
  fromCxShippingCondition.selectEntities,
);
export const selectCxShippingConditionTotal = createSelector(
  selectShippingConditionsState,
  fromCxShippingCondition.selectTotal,
);
export const selectCxShippingConditionById = () =>
  createSelector(
    selectCxShippingConditionEntities,
    (cxShippingConditionEntities, { id }) => cxShippingConditionEntities[id],
  );
export const selectCxShippingConditionsById = () =>
  createSelector(
    selectCxShippingConditionEntities,
    (cxShipmentLocationEntities, { ids }) =>
      ids.map((id) => cxShipmentLocationEntities[id]).filter(Boolean) as CxShippingCondition[],
  );
export const selectActiveCxShippingConditionId = createSelector(
  selectShippingConditionsState,
  fromCxShippingCondition.selectActiveEntityId,
);

export const selectActiveCxShippingCondition = createSelector(
  selectCxShippingConditionEntities,
  selectActiveCxShippingConditionId,
  (cxShippingConditionEntities, id) => id && cxShippingConditionEntities[id],
);
